<script>
import appConfig from "@/app.config";
import Layout from "../../layouts/auth";
import CreateCredentials from "@/components/account/CreateCredentials";

/**
 * Create Credentials component
 */
export default {
  page: {
    title: "Cambiar Contraseña",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    CreateCredentials,
    Layout
  }
};
</script>

<template>
  <Layout>
    <create-credentials submit-button-text="Cambiar Contraseña" action="reset"></create-credentials>
  </Layout>
</template>
